import { AdminNav, PrintPackageNav } from 'components'
import Flex from 'components/priority/Flex/Flex'
import * as S from './Navigation.styled'
import { NAVIGATION_HEIGHT } from './Navigation.styled'
import { useRecoilValue } from 'recoil'
import { roleAtom } from 'atoms'
import zLayers from 'utils/styling/zLayers'
import {
  isDesignerTokenSession,
  isQcTokenSession,
} from 'utils/global/designerSession'

// The admin bar is drawn in theme colours (`white`, `gray4`), so it turns dark
// in the dark palette; the package bar keeps its dark strip in both palettes.
const BAR_LOOK = {
  admin: {
    background: 'white',
    borderBottom: '1px solid',
    borderColor: 'gray4',
    outlined: false,
  },
  package: { background: 'lockedAlmostBlack', outlined: true },
}

export const Navigation = ({ type, ...props }) => {
  const userRole = useRecoilValue(roleAtom)

  if (!type) return null

  // Only the package strip collapses, for funeral-home users and for designer
  // and QC sessions: both work a fixed order and must not restage it through
  // the products/theme steps. The nav component itself must stay mounted,
  // because PrintPackageNav also bootstraps the order data the page renders
  // from. The admin bar keeps its full height for every role.
  const hideStrip =
    type === 'package' &&
    (userRole === 'fh-user' || isDesignerTokenSession() || isQcTokenSession())
  const navHeight = hideStrip ? '0' : NAVIGATION_HEIGHT
  const { outlined, ...look } = BAR_LOOK[type]

  return (
    <>
      <Flex
        full
        {...look}
        height={navHeight}
        position="fixed"
        zindex={zLayers.contentBase}
      />
      <S.Navigation
        data-testid="navigation-bar"
        $outlined={outlined}
        full
        justify="space-between"
        align="stretch"
        height={navHeight}
        padding="0 36px"
        zindex={zLayers.contentBase}
        position="fixed"
      >
        {
          {
            admin: <AdminNav />,
            package: <PrintPackageNav />,
          }[type]
        }
      </S.Navigation>
      <Flex full height={navHeight} background={look.background} {...props} />
    </>
  )
}

Navigation.displayName = 'Navigation'

export default Navigation
